{
  "logout": "Logout",
  "accessGranted": "Access Granted",
  "addNewEntity": "Add new profile",
  "viewAllProfiles": "View all profiles",
  "language": "Language",
  "resourcesArticles": "Resources and Articles",
  "contactSupport": "Contact Support",
  "updateAvatar": "Update Avatar",
  "notifications": "Notification Settings",
  "loginSettings": "Manage Login"
}
